import styled from 'styled-components'

export const Main = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  padding: 35px 0;

  @media (min-width: 1300px) {
    height: 100vh;
  }
`

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 90vw;
  height: 800px;

  position: relative;

  @media (min-width: 1300px) {
    flex-direction: initial;
    justify-content: center;
    height: 90vh;
  }

  img {
    width: 80vw;
    border-radius: 10px;

    @media (min-width: 500px) {
      max-height: 60vh;
      width: auto;
      max-width: 400px;
    }

    @media (min-width: 1300px) {
      margin: -100px 100px 50px 0;
      max-width: 500px;
    }
  }

  div {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  h2 {
    font-weight: bold;
    line-height: 50px;
    font-size: 30px;
    font-family: 'conso' !important;

    @media (min-width: 1300px) {
      font-size: 4vw;
      line-height: 150px;
    }
  }

  span {
    font-weight: bold;
  }

  h3 {
    line-height: 26px;
    font-size: 16px;

    @media (min-width: 1300px) {
      font-size: 2vw;
      line-height: 50px;
    }
  }
`

export const Botoes = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: absolute;
  bottom: 10px;

  button {
    width: 80vw;
    height: auto;
    margin: 20px;
    padding: 20px;
    background-color: #66b0b4;
    background-size: cover;
    color: white;
    font-size: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    border-radius: 99px;
    border: 1px solid #d9bf9c;
    cursor: pointer;
  }
`

export const Voltar = styled.div`
  display: flex;
  align-items: center;
  color: #642c1c;
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 3vh;
`
